import { useTranslation } from 'react-i18next';
import { BRAND } from '@/config/brand';
import { SocialTemplate, type SocialTemplateProps } from './SocialTemplate';

const LOGO_URL = 'https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/692d6394a23762baf1ff05b8/4a1265ef2_r.png';

type PostMockProps = Omit<SocialTemplateProps, 'children'> & { main?: string; sub?: string };

/** A post template: logo, headline and sub-headline on the format's background. */
export default function PostMock({ main, sub, gradient = 'from-purple-500/25 to-fuchsia-500/25', ...template }: PostMockProps) {
  const { t } = useTranslation(['admin']);
  const headline = main ?? t('admin:social.linkedinHeader.headline');
  const subline = sub ?? t('admin:social.linkedinHeader.subheadline');
  return (
    <SocialTemplate gradient={gradient} {...template}>
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient}`} />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(255,255,255,0.06),transparent_45%)]" />
      <div className="absolute inset-0 rounded-xl border border-white/10" />
      <div className="absolute right-3 top-3 sm:right-4 sm:top-4">
        <img src={LOGO_URL} alt={BRAND.name} crossOrigin="anonymous" className="h-6 w-auto opacity-90 sm:h-8" />
      </div>
      <div className="absolute inset-0 flex items-center justify-center p-6 text-center">
        <div>
          <div className="text-xl font-bold leading-tight text-white sm:text-2xl">{headline}</div>
          {subline && <div className="mt-2 text-sm text-white/80 sm:text-base">{subline}</div>}
        </div>
      </div>
    </SocialTemplate>
  );
}
